import feathers, {socketio, authentication} from '@feathersjs/client';
import io from 'socket.io-client';

const socket = io('/', {
  transports: ['websocket']
});

const feathersClient = feathers()
  .configure(socketio(socket, { timeout: 120000 }))
  .configure(authentication({ storage: window.localStorage, timeout: 120000 }));

const isAuthError = (error) => {
  const name = error && error.name ? String(error.name) : '';
  const message = error && error.message ? String(error.message) : '';
  return (
    name === 'NotAuthenticated' ||
    name === 'Forbidden' ||
    message.toLowerCase().indexOf('notauthenticated') !== -1 ||
    message.toLowerCase().indexOf('not authenticated') !== -1 ||
    message.toLowerCase().indexOf('jwt') !== -1
  );
};

const isPublicPath = (pathname) => {
  return (
    pathname === '/' ||
    pathname === '/sign-in' ||
    pathname.indexOf('/sign-in/') === 0 ||
    pathname.indexOf('/payment/') === 0 ||
    pathname.indexOf('/print/username/') === 0
  );
};

const clearAuthCacheAndRedirect = () => {
  try {
    window.localStorage.removeItem('feathers-jwt');
    window.localStorage.removeItem('jwt');
    window.localStorage.removeItem('token');
    window.sessionStorage.removeItem('feathers-jwt');
  } catch (e) {
    // ignore storage access issues and continue to redirect
  }

  if (window.caches && window.caches.keys) {
    window.caches.keys().then((keys) => {
      keys.forEach((key) => window.caches.delete(key));
    });
  }

  if (!isPublicPath(window.location.pathname)) {
    window.location.assign('/sign-in');
  }
};

const withAuthRedirect = (promiseFactory) => {
  return promiseFactory().catch((error) => {
    if (isAuthError(error)) {
      clearAuthCacheAndRedirect();
    }
    throw error;
  });
};

const originalService = feathersClient.service.bind(feathersClient);
feathersClient.service = function wrappedService (path) {
  const svc = originalService(path);
  const methods = ['find', 'get', 'create', 'update', 'patch', 'remove'];
  methods.forEach((method) => {
    if (typeof svc[method] === 'function') {
      const originalMethod = svc[method].bind(svc);
      svc[method] = (...args) => withAuthRedirect(() => originalMethod(...args));
    }
  });
  return svc;
};

export default feathersClient;



// WEBPACK FOOTER //
// ./src/services/FeathersService.js